import script from "./MainCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./MainCard.vue?vue&type=script&lang=ts&setup=true"

import "./MainCard.vue?vue&type=style&index=0&id=09d1cd88&scoped=true&lang=css"

import exportComponent from "E:\\code\\my\\bookmark.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09d1cd88"]])

export default __exports__